import { render, staticRenderFns } from "./addNewTemplate.vue?vue&type=template&id=ffde22f6&scoped=true"
import script from "./addNewTemplate.vue?vue&type=script&lang=js"
export * from "./addNewTemplate.vue?vue&type=script&lang=js"
import style0 from "./addNewTemplate.vue?vue&type=style&index=0&id=ffde22f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffde22f6",
  null
  
)

export default component.exports